import React, { ReactNode, useEffect, useState } from "react";
import { LoginResponse } from "../types";
import { useTokenStore } from "../Zustand/TokenStore";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../Zustand/AuthStore";
import {
  Avatar,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import logo from "../assets/logo-icon.png";

import Header from "./Header";
import { GridMenuIcon } from "@mui/x-data-grid";
import Sidebar from "./Sidebar";
import { LogoutRounded } from "@mui/icons-material";

type Props = {
  children: ReactNode;
  PageId?: number;
};

export default function Layout({ children, PageId }: Props) {
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const authdata: LoginResponse = useTokenStore((state) => state.AuthData);

  const navigate = useNavigate();
  const { clearAuthData, clearToken } = useTokenStore();
  const { signout } = useAuthStore();

  useEffect(() => {
    if (window.innerWidth < 768) {
      setOpen(false);
    }
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const generateInitials = (name: string) => {
    if (typeof name === "string" && name.length > 0) {
      return name.charAt(0).toUpperCase();
    } else {
      return "";
    }
  };

  const handleLogout = async () => {
    clearAuthData();
    clearToken();
    signout();
    navigate("/");
  };

  return (
    <div className="flex flex-col w-full min-h-screen max-h-max bg-white">
      <div className="fixed z-50 bg-white shadow-lg w-full ">
        <div className="flex flex-row items-center justify-between p-1 md:px-5 px-4">
          <div className="flex items-center justify-start space-x-10">
            <GridMenuIcon
              className="cursor-pointer text-primary"
              onClick={() => {
                setOpen(!open);
              }}
            />
            <div className="flex flex-row items-center space-x-2">
              <img
                src={logo}
                alt="logo-icon"
                className="duration-500 cursor-pointer h-9 w-9"
                onClick={() => navigate("/home")}
              />
              <h1 className="text-base font-medium duration-300 origin-left md:text-xl text-primary">
                Diksha.Online
              </h1>
            </div>
          </div>

          <div className="flex-row items-center hidden space-x-0 md:space-x-2 md:flex">
            <Tooltip title={`Welcome ${authdata?.Name}`}>
              <IconButton onClick={handleClick}>
                <Avatar sx={{ width: 30, height: 30, cursor: "pointer" }}>
                  {generateInitials(`${authdata?.Name}`)}
                </Avatar>
              </IconButton>
            </Tooltip>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
            >
              <div className="flex items-center justify-around px-2">
                <ListItemIcon>
                  <LogoutRounded color="primary" />
                </ListItemIcon>
                <MenuItem
                  sx={{
                    padding: "2px 8px",
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </MenuItem>
              </div>
            </Menu>
          </div>
        </div>
      </div>

      <div className="flex bg-white ">
        {/* sidebar */}
        <div className="sticky top-0 h-screen">
          <Sidebar sidebarOpen={open} onClose={() => setOpen(false)} />
        </div>

        <div className="flex-1 w-[100%] overflow-hidden max-h-fit bg-white ">
          <div className="flex flex-col items-center px-8 mt-4 md:block h-full bg-white ">
            <div className="flex flex-row items-center justify-start w-full mt-10 md:mt-16 bg-white ">
              <Header title="" PageId={PageId} />
            </div>
            <div className="w-full min-h-[78dvh] max-h-fit">{children}</div>
          </div>

          {/* footer */}
          <footer className="sticky bottom-0 flex flex-col items-center justify-center w-full py-4 text-center bg-slate-100 text-primary">
            <p className="text-sm">
              &copy; {new Date().getFullYear()} Diksha.Online All rights
              reserved.
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
}
